export default __webpack_public_path__ + "static/media/campaign-inactive.40f2d4f0.svg";